import { InvalidVerificationCode, VerificationCodeHasExpired, InvalidRefreshToken, UserNotFound } from './errorCodes.constants';

export const customError: Record<string, string> = {
  [InvalidVerificationCode]: 'Wrong verification code. Please try again or send it again',
  [VerificationCodeHasExpired]: 'Verification code has expired. Please send it again',
  [InvalidRefreshToken]: 'Your session has expired, please login.',
  [UserNotFound]: 'User not found',
};
